import type { ProjectRevenueTableDataQuery } from "@src/__generated__/urql-graphql";
import { ProjectReportBaseModel } from "../../common/models";

type TProject = NonNullable<
  ProjectRevenueTableDataQuery["projectRevenue"]
>["projects"][0];

export class ProjectRevenueModel extends ProjectReportBaseModel {
  total_invoiced: TProject["total_invoiced"];
  total_revenue_share: TProject["total_revenue_share"];
  filtered_revenue_share: TProject["filtered_revenue_share"];
  our_work_billings_for_date_range: TProject["our_work_billings_for_date_range"];
  expenses_billings_for_date_range: TProject["expenses_billings_for_date_range"];

  constructor(src: TProject) {
    super(src);
    this.total_invoiced = src.total_invoiced;
    this.total_revenue_share = src.total_revenue_share;
    this.filtered_revenue_share = src.filtered_revenue_share;
    this.our_work_billings_for_date_range =
      src.our_work_billings_for_date_range;
    this.expenses_billings_for_date_range =
      src.expenses_billings_for_date_range;
  }
}
